import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { Button, Modal } from 'react-bootstrap';
import PackagedSubDetail from '../../components/ac_packaged_unit/PackagedSubDetail';
import { defaultRejectHandler } from '../../utils/utility';
import { createACPackagedSub } from '../../redux/ac_packaged_unit/ac_packaged_sub_actions';

class ACPackagedSubCreateModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isValid: false,
      isDirty: false,
      isSubmittable: false,
    };

    this.packagedSubDetail = undefined;
  }

  onSaveHandler() {
    const newPackagedSub = this.packagedSubDetail.getWrappedInstance().getPackagedSubData();
    this.props.createACPackagedSub(newPackagedSub);
  }

  render() {
    const { isCreating, errorMessage, t, ...newProps } = this.props;
    const { isSubmittable } = this.state;
    return (
      <Modal
        {...newProps}
        bsSize="large"
        aria-labelledby="contained-modal-title-lg"
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>{t('create ac packaged sub')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <PackagedSubDetail
            ref={ref => (this.packagedSubDetail = ref)}
            onValid={isValid => this.setState({ isValid })}
            onDirty={isDirty => this.setState({ isDirty })}
            onSubmittable={isSubmittable => this.setState({ isSubmittable })}
            fieldErrors={errorMessage}
            onSubmit={() => !this.props.isCreating && !this.props.isCreated && this.onSaveHandler()}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            id="air-conditioning-package-sub-submit-create"
            disabled={!isSubmittable || isCreating}
            onClick={() => this.onSaveHandler()}
          >
            {isCreating ? `${t('saving')}...` : t('save')}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = (state, props) => ({
  errorMessage: state.ac.packagedSub.errorMessage,
  isCreating: state.ac.packagedSub.isCreating,
  acDetail: props.ac && state.ac.packagedSub.objects[props.ac.id],
});

const mapDispatchToProps = dispatch => ({
  createACPackagedSub: packagedSub =>
    defaultRejectHandler(
      dispatch(
        createACPackagedSub(
          packagedSub.name,
          packagedSub.power_required,
          packagedSub.description || '',
          packagedSub.image,
          packagedSub.cfp_value,
          packagedSub.cfp_unit,
        ),
      ),
    ),
});

export default translate('translations')(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(ACPackagedSubCreateModal),
);



// WEBPACK FOOTER //
// ./src/modal/ac_packaged_unit/ACPackagedSubCreateModal.js